"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Input = exports.InputStyle = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var utils_1 = require("./utils");
var spacing_1 = require("../spacing");
var colors_1 = require("../../util/colors");
exports.InputStyle = (0, styled_components_1.default)(spacing_1.Div)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  input {\n    ", "\n  }\n  input:focus {\n    outline: none;\n    border: 1px solid ", ";\n  }\n"], ["\n  input {\n    ", "\n  }\n  input:focus {\n    outline: none;\n    border: 1px solid ", ";\n  }\n"])), utils_1.inputStyle, colors_1.colors.brandPurple);
exports.Input = react_1.default.forwardRef(function (_a, ref) {
    var styledProps = _a.styledProps, nativeProps = __rest(_a, ["styledProps"]);
    return (react_1.default.createElement(exports.InputStyle, __assign({}, styledProps),
        react_1.default.createElement("input", __assign({ ref: ref }, nativeProps))));
});
var templateObject_1;
//# sourceMappingURL=Input.js.map